module.exports = __webpack_public_path__ + "img/hiw-1.81137f59.svg";